const textShadow = {
  name: "text-shadow",
  path: "text-shadow",
  title: "text-shadow",
  description: "Utilities for controlling the CSS text-shadow property.",
  value: {
    "text-shadow": {
      "text-shadow-2xs": "0 1px 0px var(--uni-text-shadow-color, rgb(0 0 0 / 0.05))",
      "text-shadow-xs": "0px 1px 1px var(--uni-text-shadow-color, rgb(0 0 0 / 0.05))",
      "text-shadow-sm": "0px 1px 0px var(--uni-text-shadow-color, rgb(0 0 0 / 0.075)), 0px 1px 1px var(--uni-text-shadow-color, rgb(0 0 0 / 0.075)), 0px 2px 2px var(--uni-text-shadow-color, rgb(0 0 0 / 0.075))",
      "text-shadow-md": "0px 1px 1px var(--uni-text-shadow-color, rgb(0 0 0 / 0.1)), 0px 1px 2px var(--uni-text-shadow-color, rgb(0 0 0 / 0.1)), 0px 2px 4px var(--uni-text-shadow-color, rgb(0 0 0 / 0.1))",
      "text-shadow-lg": "0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px var(--uni-text-shadow-color, rgb(0 0 0 / 0.1)), 0px 4px 8px var(--uni-text-shadow-color, rgb(0 0 0 / 0.1))",
      "text-shadow-none": "none",
      "text-shadow-inherit": "inherit",
      "text-shadow-current": "currentColor",
      "text-shadow-transparent": "transparent"
    }
  },
  exampleData: [
    {
      title: "text-shadow-sm, text-shadow-lg",
      description: "Apply different sized text shadows to an element:",
      example: {
        code: `<p class="text-shadow-2xs ...">The quick brown fox...</p>
<p class="text-shadow-xs ...">The quick brown fox...</p>
<p class="text-shadow-sm ...">The quick brown fox...</p>
<p class="text-shadow-md ...">The quick brown fox...</p>
<p class="text-shadow-lg ...">The quick brown fox...</p>
<p class="text-shadow-[1px_4px_3px_rgb(0_0_0/_0.2)] ...">The quick brown fox...</p>`
      }
    },
    {
      title: "text-shadow-sm, text-shadow-lg",
      description: "Apply different sized text shadows to an element:",
      example: {
        code: `<p class="text-color-indigo-100 text-shadow-color-indigo-800 ...">The quick brown fox...</p>
<p class="text-color-sky-100 text-shadow-color-sky-800 ...">The quick brown fox...</p>
<p class="text-color-[#d0d8e9] text-shadow-color-[#254d9b] ...">The quick brown fox...</p>`
      }
    },
  ],
  htmlData: [
    {
      title: "Text shadow",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">text-shadow-*</code> utilities to control the text-shadow of an element.
      </p>
      <div class="flex flex-col justify-center gap-6 text-color-white p-10 flex-wrap items-center bg-gradient-[linear-gradient(to_right,color-violet-500,color-fuchsia-500)]">
        <span class="text-shadow-2xs text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
        <span class="text-shadow-xs text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
        <span class="text-shadow-sm text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
        <span class="text-shadow-md text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
        <span class="text-shadow-lg text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
        <span class="text-shadow-[1px_4px_3px_rgb(0_0_0/_0.2)] text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
      </div>
      `
    },
    {
      title: "Text shadow",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">text-shadow-color-indigo-500</code> utilities to control the text-shadow of an element.
      </p>
      <div class="flex flex-col justify-center gap-6  p-10 flex-wrap items-center">
        <span class="text-shadow-lg text-color-indigo-100 text-shadow-color-indigo-800 text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
        <span class="text-shadow-lg text-color-sky-100 text-shadow-color-sky-800 text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>
        <span class="text-shadow-lg text-color-[#d0d8e9] text-shadow-color-[#254d9b] text-2xl font-bold">The quick brown fox jumps over the lazy dog.</span>      </div>
      `
    }
  ]
};

export default textShadow;
<div className="sr-only flex gap-6 items-center text-color-[#d0d8e9] text-color-indigo-100 text-color-sky-100 text-shadow-color-indigo-800 text-shadow-color-sky-800 text-shadow-color-[#254d9b]">
    <span class="text-shadow-2xs text-2xl font-bold text-shadow-[1px_4px_3px_rgb(0_0_0/_0.2)]">2xs shadow</span>
        <span class="text-shadow-xs text-2xl font-bold">xs shadow</span>
        <span class="text-shadow-sm text-2xl font-bold">sm shadow</span>
        <span class="text-shadow-md text-2xl font-bold">md shadow</span>
        <span class="text-shadow-lg text-2xl font-bold">lg shadow</span>
        <span class="text-shadow-none text-2xl font-bold">none</span>
</div>